import { render, staticRenderFns } from "./transaksi.vue?vue&type=template&id=55d80464&"
import script from "./transaksi.vue?vue&type=script&lang=js&"
export * from "./transaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports